import EditOrganisationUM from "@/views/utils/EditOrganisationUM.vue";
import AddOrganisationUM from "@/views/utils/AddOrganisationUM.vue";
import UsersOrganisationTable from "../views/utils/UsersOrganisationTable.vue";
import EditUserUM from "../views/utils/EditUserUM.vue";
import EditUser2UM from "../views/utils/EditUser2UM.vue";
import AddOrganisationUserUM from "../views/utils/AddOrganizationUserUM.vue";
import EditBank from "../views/calcsettings/EditBank.vue";
import AddBank from "../views/calcsettings/AddBank.vue";
import EditCustomer from "../views/calcsettings/EditCustomer.vue";
import AddCustomer from "../views/calcsettings/AddCustomer.vue";
import EditSituation from "../views/calcsettings/EditSituation.vue";
import AddSituation from "../views/calcsettings/AddSituation.vue";
import AddOrEditProduct from "../views/calcsettings/AddOrEditProduct.vue";
import CalculatorTariffs from "../views/calcsettings/CalculatorTariffs.vue";
import CalculatorSettings from "../views/CalculatorSettings.vue";

const menu = [
  {
    title: "Настройки Калькулятора ",
    icon: "settings",
    url: "/calcsettings",
    meta: { calcAdmin: false, bankir: true },
    id: 8,
  },
];

const routes = [
  {
    path: "/calctariff",
    name: "calctariff",
    component: CalculatorTariffs,
    meta: {
      forAuth: true,
      calcAdmin: false,
      bankir: true,
    },
  },
  {
    path: "/calcsettings",
    name: "calcsettings",
    component: CalculatorSettings,
    meta: {
      forAuth: true,
      calcAdmin: false,
      bankir: true,
    },
  },
  {
    path: "/addbank",
    name: "addbank",
    component: AddBank,
    meta: {
      forAuth: true,
      calcAdmin: false,
      bankir: true,
    },
  },
  {
    path: "/editbank",
    name: "editbank",
    component: EditBank,
    meta: {
      forAuth: true,
      calcAdmin: false,
      bankir: true,
    },
  },
  {
    path: "/editproduct",
    name: "editproduct",
    component: AddOrEditProduct,
    meta: {
      forAuth: true,
      calcAdmin: false,
      bankir: true,
    },
  },
  {
    path: "/addproduct",
    name: "addproduct",
    component: AddOrEditProduct,
    meta: {
      forAuth: true,
      calcAdmin: false,
      bankir: true,
    },
  },
  {
    path: "/addsituation",
    name: "addsituation",
    component: AddSituation,
    meta: {
      forAuth: true,
      calcAdmin: false,
      bankir: true,
    },
  },
  {
    path: "/editsituation",
    name: "editsituation",
    component: EditSituation,
    meta: {
      forAuth: true,
      calcAdmin: false,
      bankir: true,
    },
  },
  {
    path: "/editcustomer",
    name: "editcustomer",
    component: EditCustomer,
    meta: {
      forAuth: true,
      calcAdmin: false,
      bankir: true,
    },
  },
  {
    path: "/addcustomer",
    name: "addcustomer",
    component: AddCustomer,
    meta: {
      forAuth: true,
      calcAdmin: false,
      bankir: true,
    },
  },

  {
    path: "/usersorganisationtable",
    name: "usersorganisationtable",
    component: UsersOrganisationTable,
    meta: {
      forAuth: true,
      calcAdmin: false,
      bankir: true,
    },
  },
  {
    path: "/adduserum",
    name: "adduserum",
    component: AddOrganisationUserUM,
    meta: {
      forAuth: true,
      calcAdmin: false,
      bankir: true,
    },
  },
  {
    path: "/edituserum",
    name: "edituserum",
    component: EditUserUM,
    meta: {
      forAuth: true,
      calcAdmin: false,
      bankir: true,
    },
  },
  {
    path: "/edituser2um",
    name: "edituser2um",
    component: EditUser2UM,
    meta: {
      forAuth: true,
      calcAdmin: false,
      bankir: true,
    },
  },
  {
    path: "/editorganisation",
    name: "editorganisation",
    component: EditOrganisationUM,
    meta: {
      forAuth: true,
      calcAdmin: false,
      bankir: true,
    },
  },
  {
    path: "/addorganisation",
    name: "addorganisation",
    component: AddOrganisationUM,
    meta: {
      forAuth: true,
      calcAdmin: false,
      bankir: true,
    },
  },
];

export default { menu, routes };
